import { useCallback } from 'react';
import useSaveMeal from './useSaveMeal';
import { DEFAULT_FORM } from '../../../modal/views/ModalOwnMeal';

const useSaveOwnMeal = ({ currentDay, onAddSavedMeal, setMealForm, setIsManualAdd }) => {
    const { saveMeal, isSaving, isSuccess, isError, error, reset } = useSaveMeal(currentDay);

    const saveOwnMeal = useCallback(
        async ({ payload, parsed }) => {
            const { trimmedName, kcal, protein, carbs, fat } = parsed;
            const mealType = payload.meal_type;

            try {
                await saveMeal(payload);

                onAddSavedMeal(mealType, {
                    name: trimmedName,
                    kcal: kcal ?? 0,
                    protein: protein ?? 0,
                    carbs: carbs ?? 0,
                    fat: fat ?? 0
                });

                setMealForm(DEFAULT_FORM);
                setIsManualAdd(false);
                reset();
            } catch (error) {
                console.error('Failed to save meal:', error);
            }
        },
        [saveMeal, onAddSavedMeal, setMealForm, setIsManualAdd, reset]
    );

    return { saveOwnMeal, isSaving, isSuccess, isError, error };
};

export default useSaveOwnMeal;
